import React from "react";

import { FileRecordDetailsPageHeader } from "../../../details/header/FileRecordDetailsPageHeader";
import { FileRecordDetailsStateProvider } from "../../../details/hooks/FileRecordDetailsStateProvider";
import { EditFileRecordContentForm } from "./EditFileRecordContentForm";

export const EditFileRecordContentDashboard = (): JSX.Element => {
    return (
        <FileRecordDetailsStateProvider>
            <FileRecordDetailsPageHeader />
            <EditFileRecordContentForm />
        </FileRecordDetailsStateProvider>
    );
};
